import { useEffect, useState } from "react";
import { Segmented } from "antd";
import { StudentCard, StudentInfo, StudyYear } from "./data";
import { appCRUD } from "../../../actions/app";
import { Loader } from "rsuite";
import { useNotification } from "../../../utils/notification";

export const StudentDetails = (props) => {
  const { dataId } = props;
  const [index, setIndex] = useState(0)
  const [activeTab, setActiveTab] = useState("student");
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(false);
  const openNotification = useNotification();

  useEffect(() => {
    if (dataId) {
      setLoading(true);
      setTimeout(() => {
        appCRUD
          .loadStudentData(dataId)
          .then((resp) => {
            setStudent(resp.data);
          })
          .catch((error) => {
            const responseData = error?.response?.data;
            let errorMessage = "Something went wrong. Please try again.";
            if (typeof responseData === "string") {
              errorMessage = responseData;
            } else if (responseData?.error) {
              errorMessage = responseData.error;
            } else if (responseData?.detail) {
              errorMessage = responseData.detail;
            } else if (responseData?.message) {
              errorMessage = responseData.message;
            } else if (typeof responseData === "object") {
              const firstKey = Object.keys(responseData)[0];
              const firstError = responseData[firstKey];
              if (Array.isArray(firstError)) {
                errorMessage = `${firstError[0]}`;
              }
            }
            openNotification(
              "error",
              "Error",
              <>
                Sorry...!
                <br />
                {errorMessage}
              </>
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    }
  }, [dataId, index]);

  return (
    <>
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-primary">Student Details</p>
          </div>
          <hr className="mt-3" />
        </div>
        <div className="row">
          <div className="col-12">
            <Segmented
              size="large"
              block
              onChange={(e) => setActiveTab(e)}
              options={[
                {
                  label: "Student Info",
                  value: "student",
                  icon: <i className="bi bi-person fs-3" />,
                },
                {
                  label: "Year of Study",
                  value: "study",
                  icon: <i className="bi bi-calendar-date fs-3" />,
                },
                {
                  label: "List of ID Card",
                  value: "card",
                  icon: <i className="bi bi-person-bounding-box fs-3" />,
                },
              ]}
            />
          </div>
          <hr className="mt-3" style={{ border: "1px solid #d26e29" }} />
        </div>
        {activeTab === "student" && (
          <StudentInfo
            dataId={dataId}
            data={student}
            index={index}
            setIndex={setIndex}
          />
        )}
        {activeTab === "study" && <StudyYear dataId={dataId} />}
        {activeTab === "card" && (
          <StudentCard dataId={dataId} student={student} />
        )}
        {loading && (
          <Loader
            size="lg"
            speed="slow"
            center
            backdrop
            style={{ color: "#d26e29" }}
            content="Please wait..."
            vertical
          />
        )}
      </div>
    </>
  );
};
